@file:OptIn(InternalResourceApi::class)

package loco

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/loco/"

@delegate:ResourceContentHash(-240_336_939)
public val Res.string.GENERAL_WEIGHT_TSP_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_TSP_FORMAT", "GENERAL_WEIGHT_TSP_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5159, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5239, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5375, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4891, 45),
      ))
    }

@delegate:ResourceContentHash(-947_714_304)
public val Res.string.HEALTH_KIT_APPLE_HEALTH_NAME: StringResource by lazy {
      StringResource("string:HEALTH_KIT_APPLE_HEALTH_NAME", "HEALTH_KIT_APPLE_HEALTH_NAME", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5205, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5301, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5433, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4937, 52),
      ))
    }

@delegate:ResourceContentHash(-845_495_140)
public val Res.string.HEALTH_KIT_CONNECTION_TITLE_FORMAT: StringResource by lazy {
      StringResource("string:HEALTH_KIT_CONNECTION_TITLE_FORMAT", "HEALTH_KIT_CONNECTION_TITLE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5258, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5354, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5486, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4990, 62),
      ))
    }

@delegate:ResourceContentHash(374_878_339)
public val Res.string.HEALTH_KIT_CONNECT_BUTTON: StringResource by lazy {
      StringResource("string:HEALTH_KIT_CONNECT_BUTTON", "HEALTH_KIT_CONNECT_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5321, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5421, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5553, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5053, 45),
      ))
    }

@delegate:ResourceContentHash(-584_221_376)
public val Res.string.HEALTH_KIT_HEALTH_CONNECT_NAME: StringResource by lazy {
      StringResource("string:HEALTH_KIT_HEALTH_CONNECT_NAME", "HEALTH_KIT_HEALTH_CONNECT_NAME", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5367, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5467, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5599, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5099, 58),
      ))
    }

@delegate:ResourceContentHash(-1_507_885_409)
public val Res.string.HEALTH_KIT_MANAGE_HINT_ANDROID_FORMAT: StringResource by lazy {
      StringResource("string:HEALTH_KIT_MANAGE_HINT_ANDROID_FORMAT", "HEALTH_KIT_MANAGE_HINT_ANDROID_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5426, 177),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5526, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5658, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5158, 129),
      ))
    }

@delegate:ResourceContentHash(-876_875_917)
public val Res.string.HEALTH_KIT_MANAGE_HINT_IOS_FORMAT: StringResource by lazy {
      StringResource("string:HEALTH_KIT_MANAGE_HINT_IOS_FORMAT", "HEALTH_KIT_MANAGE_HINT_IOS_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5604, 301),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5672, 289),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5812, 321),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5288, 241),
      ))
    }

@delegate:ResourceContentHash(-1_983_722_249)
public val Res.string.HEALTH_KIT_MANAGE_PERMISSIONS_BUTTON: StringResource by lazy {
      StringResource("string:HEALTH_KIT_MANAGE_PERMISSIONS_BUTTON", "HEALTH_KIT_MANAGE_PERMISSIONS_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5906, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5962, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6134, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5530, 68),
      ))
    }

@delegate:ResourceContentHash(1_032_318_782)
public val Res.string.HEALTH_KIT_SYNC_DESCRIPTION: StringResource by lazy {
      StringResource("string:HEALTH_KIT_SYNC_DESCRIPTION", "HEALTH_KIT_SYNC_DESCRIPTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5983, 203),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6031, 159),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6211, 195),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5599, 143),
      ))
    }

@delegate:ResourceContentHash(630_826_176)
public val Res.string.HEALTH_LOG_SAVE_BUTTON: StringResource by lazy {
      StringResource("string:HEALTH_LOG_SAVE_BUTTON", "HEALTH_LOG_SAVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6187, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6191, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6407, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5743, 38),
      ))
    }

@delegate:ResourceContentHash(437_537_384)
public val Res.string.HEALTH_LOG_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:HEALTH_LOG_SCREEN_TITLE", "HEALTH_LOG_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6230, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6234, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6450, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5782, 47),
      ))
    }

@delegate:ResourceContentHash(-1_379_943_212)
public val Res.string.HEALTH_TOOLS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:HEALTH_TOOLS_SCREEN_TITLE", "HEALTH_TOOLS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6294, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6294, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6518, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5830, 49),
      ))
    }

@delegate:ResourceContentHash(-1_858_052_674)
public val Res.string.INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT: StringResource by lazy {
      StringResource("string:INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT", "INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6352, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6356, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6576, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5880, 64),
      ))
    }

@delegate:ResourceContentHash(-972_960_409)
public val Res.string.INSIGHTS_FAVORITES_EMPTY_MESSAGE: StringResource by lazy {
      StringResource("string:INSIGHTS_FAVORITES_EMPTY_MESSAGE", "INSIGHTS_FAVORITES_EMPTY_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6425, 208),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6429, 184),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6653, 212),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5945, 168),
      ))
    }

@delegate:ResourceContentHash(-1_477_019_615)
public val Res.string.INSIGHTS_FAVORITES_EMPTY_TITLE: StringResource by lazy {
      StringResource("string:INSIGHTS_FAVORITES_EMPTY_TITLE", "INSIGHTS_FAVORITES_EMPTY_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6634, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6614, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6866, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6114, 70),
      ))
    }

@delegate:ResourceContentHash(2_134_142_920)
public val Res.string.INSIGHTS_GREETING: StringResource by lazy {
      StringResource("string:INSIGHTS_GREETING", "INSIGHTS_GREETING", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6749, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6741, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6997, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6229, 45),
      ))
    }

@delegate:ResourceContentHash(234_037_199)
public val Res.string.INSIGHTS_GREETING_NAME_FALLBACK: StringResource by lazy {
      StringResource("string:INSIGHTS_GREETING_NAME_FALLBACK", "INSIGHTS_GREETING_NAME_FALLBACK", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6705, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6697, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6949, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6185, 43),
      ))
    }

@delegate:ResourceContentHash(931_099_080)
public val Res.string.INSIGHTS_RECENTS_EMPTY_MESSAGE: StringResource by lazy {
      StringResource("string:INSIGHTS_RECENTS_EMPTY_MESSAGE", "INSIGHTS_RECENTS_EMPTY_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6795, 162),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6787, 154),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7051, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6275, 150),
      ))
    }

@delegate:ResourceContentHash(-440_105_474)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES", "INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6958, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6942, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7230, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6426, 64),
      ))
    }

@delegate:ResourceContentHash(-239_059_140)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS", "INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7023, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7007, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7295, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6491, 58),
      ))
    }

@delegate:ResourceContentHash(1_058_712_311)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS", "INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7082, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7062, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7354, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6550, 64),
      ))
    }

@delegate:ResourceContentHash(780_301_412)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_RECIPES: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_RECIPES", "INSIGHTS_SAVED_CONTENT_HEADER_RECIPES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7147, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7135, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7423, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6615, 57),
      ))
    }

@delegate:ResourceContentHash(-857_941_281)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS", "INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7205, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7193, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7481, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6673, 58),
      ))
    }

@delegate:ResourceContentHash(1_278_090_331)
public val Res.string.INSIGHTS_TAB_ALL: StringResource by lazy {
      StringResource("string:INSIGHTS_TAB_ALL", "INSIGHTS_TAB_ALL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7264, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7260, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7548, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6732, 28),
      ))
    }

@delegate:ResourceContentHash(-665_478_731)
public val Res.string.INSIGHTS_TAB_FAVORITES: StringResource by lazy {
      StringResource("string:INSIGHTS_TAB_FAVORITES", "INSIGHTS_TAB_FAVORITES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7297, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7293, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7581, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6761, 42),
      ))
    }

@delegate:ResourceContentHash(-882_198_354)
public val Res.string.INSIGHTS_TAB_RECENTLY_VIEWED: StringResource by lazy {
      StringResource("string:INSIGHTS_TAB_RECENTLY_VIEWED", "INSIGHTS_TAB_RECENTLY_VIEWED", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7340, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7336, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7624, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6804, 56),
      ))
    }

@delegate:ResourceContentHash(-1_633_703_834)
public val Res.string.LEGAL_PRODUCT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LEGAL_PRODUCT_SCREEN_TITLE", "LEGAL_PRODUCT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7401, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7401, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7689, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6861, 42),
      ))
    }

@delegate:ResourceContentHash(358_438_978)
public val Res.string.LIFE_TODAY_ACTIVITY_CARD_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_ACTIVITY_CARD_LABEL", "LIFE_TODAY_ACTIVITY_CARD_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7452, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7444, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7732, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6904, 50),
      ))
    }

@delegate:ResourceContentHash(846_762_674)
public val Res.string.LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT: StringResource by lazy {
      StringResource("string:LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT", "LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7507, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7495, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7783, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6955, 68),
      ))
    }

@delegate:ResourceContentHash(81_254_403)
public val Res.string.LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT: StringResource by lazy {
      StringResource("string:LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT", "LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7576, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7564, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7852, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7024, 64),
      ))
    }

@delegate:ResourceContentHash(-42_105_663)
public val Res.string.LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT: StringResource by lazy {
      StringResource("string:LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT", "LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7649, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7633, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7925, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7089, 68),
      ))
    }

@delegate:ResourceContentHash(2_028_697_035)
public val Res.string.LIFE_TODAY_DAILY_TASKS_SECTION: StringResource by lazy {
      StringResource("string:LIFE_TODAY_DAILY_TASKS_SECTION", "LIFE_TODAY_DAILY_TASKS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7718, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7706, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7998, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7158, 54),
      ))
    }

@delegate:ResourceContentHash(332_779_021)
public val Res.string.LIFE_TODAY_LOG_SYMPTOMS_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_LOG_SYMPTOMS_LABEL", "LIFE_TODAY_LOG_SYMPTOMS_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7781, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7765, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8065, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7213, 49),
      ))
    }

@delegate:ResourceContentHash(1_643_208_168)
public val Res.string.LIFE_TODAY_MEAL_PLAN_CARD_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_MEAL_PLAN_CARD_LABEL", "LIFE_TODAY_MEAL_PLAN_CARD_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7831, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7815, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8119, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7263, 51),
      ))
    }

@delegate:ResourceContentHash(1_325_492_401)
public val Res.string.LIFE_TODAY_WATER_CARD_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_WATER_CARD_LABEL", "LIFE_TODAY_WATER_CARD_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7887, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7875, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8191, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7315, 43),
      ))
    }

@delegate:ResourceContentHash(-1_084_134_679)
public val Res.string.LIFE_TODAY_WEIGHT_CARD_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_WEIGHT_CARD_LABEL", "LIFE_TODAY_WEIGHT_CARD_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7931, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7919, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8231, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7359, 44),
      ))
    }

@delegate:ResourceContentHash(-919_120_266)
public val Res.string.LOGIN_CONTACT_US_BUTTON: StringResource by lazy {
      StringResource("string:LOGIN_CONTACT_US_BUTTON", "LOGIN_CONTACT_US_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7980, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7964, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8276, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7404, 47),
      ))
    }

@delegate:ResourceContentHash(131_724_923)
public val Res.string.LOGIN_EMAIL_PLACEHOLDER: StringResource by lazy {
      StringResource("string:LOGIN_EMAIL_PLACEHOLDER", "LOGIN_EMAIL_PLACEHOLDER", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8040, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8012, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8328, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7452, 39),
      ))
    }

@delegate:ResourceContentHash(1_746_448_206)
public val Res.string.LOGIN_EMAIL_SENT_INSTRUCTIONS: StringResource by lazy {
      StringResource("string:LOGIN_EMAIL_SENT_INSTRUCTIONS", "LOGIN_EMAIL_SENT_INSTRUCTIONS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8080, 357),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8072, 369),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8368, 401),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7492, 305),
      ))
    }

@delegate:ResourceContentHash(-1_252_128_198)
public val Res.string.LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT: StringResource by lazy {
      StringResource("string:LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT", "LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8438, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8442, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8770, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7798, 95),
      ))
    }

@delegate:ResourceContentHash(35_747_287)
public val Res.string.LOGIN_FORGOT_PASSWORD_BUTTON: StringResource by lazy {
      StringResource("string:LOGIN_FORGOT_PASSWORD_BUTTON", "LOGIN_FORGOT_PASSWORD_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8550, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8586, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8906, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7894, 60),
      ))
    }

@delegate:ResourceContentHash(-1_123_367_987)
public val Res.string.LOGIN_LOGIN_BUTTON: StringResource by lazy {
      StringResource("string:LOGIN_LOGIN_BUTTON", "LOGIN_LOGIN_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8615, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8659, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8975, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7955, 34),
      ))
    }

@delegate:ResourceContentHash(-884_429_840)
public val Res.string.LOGIN_PASSWORD_PLACEHOLDER: StringResource by lazy {
      StringResource("string:LOGIN_PASSWORD_PLACEHOLDER", "LOGIN_PASSWORD_PLACEHOLDER", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8654, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8706, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9014, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7990, 46),
      ))
    }

@delegate:ResourceContentHash(-1_123_367_987)
public val Res.string.LOGIN_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOGIN_SCREEN_TITLE", "LOGIN_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8701, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8757, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9065, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8037, 34),
      ))
    }

@delegate:ResourceContentHash(1_308_887_848)
public val Res.string.LOG_FOOD_ADD_FOOD_ACTION_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_ADD_FOOD_ACTION_BUTTON", "LOG_FOOD_ADD_FOOD_ACTION_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8740, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8804, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9104, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8072, 43),
      ))
    }

@delegate:ResourceContentHash(-1_309_113_000)
public val Res.string.LOG_FOOD_ADD_MEAL_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_ADD_MEAL_SCREEN_TITLE", "LOG_FOOD_ADD_MEAL_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8796, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8856, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9156, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8116, 54),
      ))
    }

@delegate:ResourceContentHash(-822_112_918)
public val Res.string.LOG_FOOD_AMOUNT_FIELD_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_AMOUNT_FIELD_LABEL", "LOG_FOOD_AMOUNT_FIELD_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8871, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8919, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9219, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8171, 43),
      ))
    }

@delegate:ResourceContentHash(-1_684_385_530)
public val Res.string.LOG_FOOD_CAMERA_CANCEL_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_CAMERA_CANCEL_BUTTON", "LOG_FOOD_CAMERA_CANCEL_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8915, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8967, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9267, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8215, 45),
      ))
    }

@delegate:ResourceContentHash(-1_888_846_898)
public val Res.string.LOG_FOOD_CAMERA_LOADING_MESSAGE: StringResource by lazy {
      StringResource("string:LOG_FOOD_CAMERA_LOADING_MESSAGE", "LOG_FOOD_CAMERA_LOADING_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8965, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9017, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9317, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8261, 95),
      ))
    }

@delegate:ResourceContentHash(-1_442_473_717)
public val Res.string.LOG_FOOD_CAMERA_SCAN_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_CAMERA_SCAN_BUTTON", "LOG_FOOD_CAMERA_SCAN_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9061, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9125, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9429, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8357, 43),
      ))
    }

@delegate:ResourceContentHash(-1_146_069_383)
public val Res.string.LOG_FOOD_CAMERA_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_CAMERA_SCREEN_TITLE", "LOG_FOOD_CAMERA_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9109, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9173, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9477, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8401, 60),
      ))
    }

@delegate:ResourceContentHash(-911_938_831)
public val Res.string.LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE: StringResource by lazy {
      StringResource("string:LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE", "LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9178, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9238, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9546, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8462, 92),
      ))
    }

@delegate:ResourceContentHash(771_195_088)
public val Res.string.LOG_FOOD_FIND_FOOD_EMPTY_TITLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_FIND_FOOD_EMPTY_TITLE", "LOG_FOOD_FIND_FOOD_EMPTY_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9295, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9347, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9663, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8555, 70),
      ))
    }

@delegate:ResourceContentHash(-414_665_322)
public val Res.string.LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON", "LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9398, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9442, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9754, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8626, 62),
      ))
    }

@delegate:ResourceContentHash(1_671_510_126)
public val Res.string.LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER: StringResource by lazy {
      StringResource("string:LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER", "LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9465, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9525, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9833, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8689, 63),
      ))
    }

@delegate:ResourceContentHash(1_152_338_271)
public val Res.string.LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL", "LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9529, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9589, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9901, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8753, 61),
      ))
    }

@delegate:ResourceContentHash(427_970_713)
public val Res.string.LOG_FOOD_FOOD_DETAILS_CARBS_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_CARBS_LABEL", "LOG_FOOD_FOOD_DETAILS_CARBS_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9591, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9651, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9963, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8815, 49),
      ))
    }

@delegate:ResourceContentHash(-2_106_960_933)
public val Res.string.LOG_FOOD_FOOD_DETAILS_FAT_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_FAT_LABEL", "LOG_FOOD_FOOD_DETAILS_FAT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9653, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9713, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10021, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8865, 47),
      ))
    }

@delegate:ResourceContentHash(70_773_492)
public val Res.string.LOG_FOOD_FOOD_DETAILS_FIBER_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_FIBER_LABEL", "LOG_FOOD_FOOD_DETAILS_FIBER_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9701, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9765, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10073, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8913, 49),
      ))
    }

@delegate:ResourceContentHash(137_085_866)
public val Res.string.LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL", "LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9763, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9815, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10127, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8963, 55),
      ))
    }

@delegate:ResourceContentHash(-172_425_324)
public val Res.string.LOG_FOOD_LOG_TIME_FIELD_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_LOG_TIME_FIELD_LABEL", "LOG_FOOD_LOG_TIME_FIELD_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9819, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9875, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10187, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9019, 49),
      ))
    }

@delegate:ResourceContentHash(-1_554_853_115)
public val Res.string.LOG_FOOD_SCAN_ERROR_IMAGE_TOO_LARGE: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_ERROR_IMAGE_TOO_LARGE", "LOG_FOOD_SCAN_ERROR_IMAGE_TOO_LARGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9885, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9933, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10253, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9069, 95),
      ))
    }

@delegate:ResourceContentHash(1_667_918_201)
public val Res.string.LOG_FOOD_SCAN_ERROR_NOT_FOOD: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_ERROR_NOT_FOOD", "LOG_FOOD_SCAN_ERROR_NOT_FOOD", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9997, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10057, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10357, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9165, 104),
      ))
    }

@delegate:ResourceContentHash(1_407_451_754)
public val Res.string.LOG_FOOD_SCAN_ERROR_QUOTA_EXCEEDED: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_ERROR_QUOTA_EXCEEDED", "LOG_FOOD_SCAN_ERROR_QUOTA_EXCEEDED", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10122, 142),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10182, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10478, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9270, 122),
      ))
    }

@delegate:ResourceContentHash(1_625_489_822)
public val Res.string.LOG_FOOD_SCAN_ERROR_SERVICE_UNAVAILABLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_ERROR_SERVICE_UNAVAILABLE", "LOG_FOOD_SCAN_ERROR_SERVICE_UNAVAILABLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10265, 151),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10333, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10625, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9393, 123),
      ))
    }

@delegate:ResourceContentHash(-1_943_348_278)
public val Res.string.LOG_FOOD_SCAN_FOOD_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_FOOD_BUTTON", "LOG_FOOD_SCAN_FOOD_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10417, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10473, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10765, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9517, 45),
      ))
    }

@delegate:ResourceContentHash(1_308_887_848)
public val Res.string.LOG_FOOD_SCAN_RESULTS_ADD_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_ADD_BUTTON", "LOG_FOOD_SCAN_RESULTS_ADD_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10479, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10527, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10827, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9563, 44),
      ))
    }

@delegate:ResourceContentHash(-1_159_753_688)
public val Res.string.LOG_FOOD_SCAN_RESULTS_CLOSE_BUTTON: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_CLOSE_BUTTON", "LOG_FOOD_SCAN_RESULTS_CLOSE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10536, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10580, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10880, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9608, 50),
      ))
    }

@delegate:ResourceContentHash(-1_684_385_530)
public val Res.string.LOG_FOOD_SCAN_RESULTS_DELETE_CANCEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_DELETE_CANCEL", "LOG_FOOD_SCAN_RESULTS_DELETE_CANCEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10595, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10631, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10931, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9659, 51),
      ))
    }

@delegate:ResourceContentHash(1_508_685_540)
public val Res.string.LOG_FOOD_SCAN_RESULTS_DELETE_CONFIRM: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_DELETE_CONFIRM", "LOG_FOOD_SCAN_RESULTS_DELETE_CONFIRM", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10651, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10687, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10987, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9711, 52),
      ))
    }

@delegate:ResourceContentHash(-263_192_608)
public val Res.string.LOG_FOOD_SCAN_RESULTS_DELETE_ITEM_TITLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_DELETE_ITEM_TITLE", "LOG_FOOD_SCAN_RESULTS_DELETE_ITEM_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10708, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10744, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11044, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9764, 71),
      ))
    }

@delegate:ResourceContentHash(1_793_564_813)
public val Res.string.LOG_FOOD_SCAN_RESULTS_TITLE: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_TITLE", "LOG_FOOD_SCAN_RESULTS_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10792, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10828, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11128, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9836, 47),
      ))
    }

@delegate:ResourceContentHash(1_044_493_803)
public val Res.string.LOG_FOOD_SCAN_RESULTS_TOTAL_LABEL: StringResource by lazy {
      StringResource("string:LOG_FOOD_SCAN_RESULTS_TOTAL_LABEL", "LOG_FOOD_SCAN_RESULTS_TOTAL_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10856, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10884, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11188, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9884, 49),
      ))
    }

@delegate:ResourceContentHash(-1_310_097_761)
public val Res.string.LOG_PERIOD_MARK_DATES_TITLE: StringResource by lazy {
      StringResource("string:LOG_PERIOD_MARK_DATES_TITLE", "LOG_PERIOD_MARK_DATES_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10906, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10934, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11238, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9934, 59),
      ))
    }

@delegate:ResourceContentHash(1_138_601_962)
public val Res.string.LOG_SYMPTOMS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOG_SYMPTOMS_SCREEN_TITLE", "LOG_SYMPTOMS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10978, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11018, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11318, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9994, 49),
      ))
    }

@delegate:ResourceContentHash(-1_159_753_688)
public val Res.string.LOG_WATER_CLOSE_BUTTON: StringResource by lazy {
      StringResource("string:LOG_WATER_CLOSE_BUTTON", "LOG_WATER_CLOSE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11044, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11080, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11388, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10044, 38),
      ))
    }

@delegate:ResourceContentHash(2_000_318_750)
public val Res.string.LOG_WATER_PERSONAL_AMOUNT_LABEL: StringResource by lazy {
      StringResource("string:LOG_WATER_PERSONAL_AMOUNT_LABEL", "LOG_WATER_PERSONAL_AMOUNT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11091, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11119, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11427, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10083, 79),
      ))
    }

@delegate:ResourceContentHash(1_648_635_578)
public val Res.string.LOG_WATER_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LOG_WATER_SCREEN_TITLE", "LOG_WATER_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11179, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11199, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11527, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10163, 46),
      ))
    }

@delegate:ResourceContentHash(131_724_923)
public val Res.string.MAGIC_LINK_EMAIL_PLACEHOLDER: StringResource by lazy {
      StringResource("string:MAGIC_LINK_EMAIL_PLACEHOLDER", "MAGIC_LINK_EMAIL_PLACEHOLDER", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11230, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11250, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11582, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10210, 44),
      ))
    }

@delegate:ResourceContentHash(2_112_206_338)
public val Res.string.MAGIC_LINK_INSTRUCTIONS: StringResource by lazy {
      StringResource("string:MAGIC_LINK_INSTRUCTIONS", "MAGIC_LINK_INSTRUCTIONS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11275, 363),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11315, 327),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11627, 391),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10255, 299),
      ))
    }

@delegate:ResourceContentHash(360_086_602)
public val Res.string.MAGIC_LINK_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:MAGIC_LINK_SCREEN_TITLE", "MAGIC_LINK_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11639, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11643, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12019, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10555, 51),
      ))
    }

@delegate:ResourceContentHash(407_645_370)
public val Res.string.MAGIC_LINK_SEND_BUTTON: StringResource by lazy {
      StringResource("string:MAGIC_LINK_SEND_BUTTON", "MAGIC_LINK_SEND_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11695, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11711, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12079, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10607, 50),
      ))
    }

@delegate:ResourceContentHash(-1_273_654_431)
public val Res.string.MAGIC_LINK_SUCCESS_MESSAGE: StringResource by lazy {
      StringResource("string:MAGIC_LINK_SUCCESS_MESSAGE", "MAGIC_LINK_SUCCESS_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11766, 210),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11786, 214),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12158, 222),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10658, 170),
      ))
    }

@delegate:ResourceContentHash(438_418_870)
public val Res.string.MAGIC_LINK_SUCCESS_TITLE: StringResource by lazy {
      StringResource("string:MAGIC_LINK_SUCCESS_TITLE", "MAGIC_LINK_SUCCESS_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11977, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12001, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12381, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10829, 56),
      ))
    }

@delegate:ResourceContentHash(-1_778_437_004)
public val Res.string.MAIN_BANNER_APP_PROMO_TITLE: StringResource by lazy {
      StringResource("string:MAIN_BANNER_APP_PROMO_TITLE", "MAIN_BANNER_APP_PROMO_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12042, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12074, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12442, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10886, 111),
      ))
    }

@delegate:ResourceContentHash(1_360_514_944)
public val Res.string.MAIN_NAVIGATION_CHAT_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_CHAT_LABEL", "MAIN_NAVIGATION_CHAT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12178, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12222, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12602, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10998, 42),
      ))
    }

@delegate:ResourceContentHash(-1_137_962_096)
public val Res.string.MAIN_NAVIGATION_DAILY_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_DAILY_LABEL", "MAIN_NAVIGATION_DAILY_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12221, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12265, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12645, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11041, 43),
      ))
    }

@delegate:ResourceContentHash(1_170_661_875)
public val Res.string.MAIN_NAVIGATION_INSIGHTS_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_INSIGHTS_LABEL", "MAIN_NAVIGATION_INSIGHTS_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12269, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12309, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12693, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11085, 50),
      ))
    }

@delegate:ResourceContentHash(-1_446_105_502)
public val Res.string.MAIN_NAVIGATION_MAIN_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_MAIN_LABEL", "MAIN_NAVIGATION_MAIN_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12320, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12364, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12744, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11136, 42),
      ))
    }

@delegate:ResourceContentHash(1_575_095_729)
public val Res.string.MAIN_NAVIGATION_ME_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_ME_LABEL", "MAIN_NAVIGATION_ME_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12363, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12411, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12791, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11179, 36),
      ))
    }

@delegate:ResourceContentHash(1_804_211_963)
public val Res.string.MAIN_NAVIGATION_TODAY_LABEL: StringResource by lazy {
      StringResource("string:MAIN_NAVIGATION_TODAY_LABEL", "MAIN_NAVIGATION_TODAY_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12400, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12448, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12828, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11216, 43),
      ))
    }

@delegate:ResourceContentHash(1_246_201_306)
public val Res.string.MEAL_PLAN_LOG_FOOD_BUTTON: StringResource by lazy {
      StringResource("string:MEAL_PLAN_LOG_FOOD_BUTTON", "MEAL_PLAN_LOG_FOOD_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12444, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12488, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12880, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11260, 37),
      ))
    }

@delegate:ResourceContentHash(1_804_211_963)
public val Res.string.MED_TODAY_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:MED_TODAY_SCREEN_TITLE", "MED_TODAY_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12490, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12534, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12926, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11298, 38),
      ))
    }

@delegate:ResourceContentHash(-749_929_503)
public val Res.string.MED_TODAY_STEPS_FORMAT: StringResource by lazy {
      StringResource("string:MED_TODAY_STEPS_FORMAT", "MED_TODAY_STEPS_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12529, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12569, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12973, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11337, 54),
      ))
    }

@delegate:ResourceContentHash(-42_542_446)
public val Res.string.ME_BMI_GOAL_VALUE_FORMAT: StringResource by lazy {
      StringResource("string:ME_BMI_GOAL_VALUE_FORMAT", "ME_BMI_GOAL_VALUE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12588, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12624, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13032, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11392, 48),
      ))
    }

@delegate:ResourceContentHash(-329_178_362)
public val Res.string.ME_CALORIES_HISTORY_SECTION: StringResource by lazy {
      StringResource("string:ME_CALORIES_HISTORY_SECTION", "ME_CALORIES_HISTORY_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12637, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12673, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13085, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11441, 55),
      ))
    }

@delegate:ResourceContentHash(1_433_218_705)
public val Res.string.ME_DAYS_IN_A_ROW_LABEL: StringResource by lazy {
      StringResource("string:ME_DAYS_IN_A_ROW_LABEL", "ME_DAYS_IN_A_ROW_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12697, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12733, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13145, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11497, 50),
      ))
    }

@delegate:ResourceContentHash(-822_320_504)
public val Res.string.ME_DAYS_IN_A_ROW_VALUE: StringResource by lazy {
      StringResource("string:ME_DAYS_IN_A_ROW_VALUE", "ME_DAYS_IN_A_ROW_VALUE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12748, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12784, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13200, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11548, 42),
      ))
    }

@delegate:ResourceContentHash(1_073_534_209)
public val Res.string.ME_SCREEN_TITLE_FORMAT: StringResource by lazy {
      StringResource("string:ME_SCREEN_TITLE_FORMAT", "ME_SCREEN_TITLE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12791, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12827, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13243, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11591, 42),
      ))
    }

@delegate:ResourceContentHash(-868_011_285)
public val Res.string.ME_WEIGHT_HISTORY_SECTION: StringResource by lazy {
      StringResource("string:ME_WEIGHT_HISTORY_SECTION", "ME_WEIGHT_HISTORY_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12838, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12874, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13294, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11634, 53),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("GENERAL_WEIGHT_TSP_FORMAT", Res.string.GENERAL_WEIGHT_TSP_FORMAT)
  map.put("HEALTH_KIT_APPLE_HEALTH_NAME", Res.string.HEALTH_KIT_APPLE_HEALTH_NAME)
  map.put("HEALTH_KIT_CONNECTION_TITLE_FORMAT", Res.string.HEALTH_KIT_CONNECTION_TITLE_FORMAT)
  map.put("HEALTH_KIT_CONNECT_BUTTON", Res.string.HEALTH_KIT_CONNECT_BUTTON)
  map.put("HEALTH_KIT_HEALTH_CONNECT_NAME", Res.string.HEALTH_KIT_HEALTH_CONNECT_NAME)
  map.put("HEALTH_KIT_MANAGE_HINT_ANDROID_FORMAT", Res.string.HEALTH_KIT_MANAGE_HINT_ANDROID_FORMAT)
  map.put("HEALTH_KIT_MANAGE_HINT_IOS_FORMAT", Res.string.HEALTH_KIT_MANAGE_HINT_IOS_FORMAT)
  map.put("HEALTH_KIT_MANAGE_PERMISSIONS_BUTTON", Res.string.HEALTH_KIT_MANAGE_PERMISSIONS_BUTTON)
  map.put("HEALTH_KIT_SYNC_DESCRIPTION", Res.string.HEALTH_KIT_SYNC_DESCRIPTION)
  map.put("HEALTH_LOG_SAVE_BUTTON", Res.string.HEALTH_LOG_SAVE_BUTTON)
  map.put("HEALTH_LOG_SCREEN_TITLE", Res.string.HEALTH_LOG_SCREEN_TITLE)
  map.put("HEALTH_TOOLS_SCREEN_TITLE", Res.string.HEALTH_TOOLS_SCREEN_TITLE)
  map.put("INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT", Res.string.INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT)
  map.put("INSIGHTS_FAVORITES_EMPTY_MESSAGE", Res.string.INSIGHTS_FAVORITES_EMPTY_MESSAGE)
  map.put("INSIGHTS_FAVORITES_EMPTY_TITLE", Res.string.INSIGHTS_FAVORITES_EMPTY_TITLE)
  map.put("INSIGHTS_GREETING", Res.string.INSIGHTS_GREETING)
  map.put("INSIGHTS_GREETING_NAME_FALLBACK", Res.string.INSIGHTS_GREETING_NAME_FALLBACK)
  map.put("INSIGHTS_RECENTS_EMPTY_MESSAGE", Res.string.INSIGHTS_RECENTS_EMPTY_MESSAGE)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_RECIPES", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_RECIPES)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS)
  map.put("INSIGHTS_TAB_ALL", Res.string.INSIGHTS_TAB_ALL)
  map.put("INSIGHTS_TAB_FAVORITES", Res.string.INSIGHTS_TAB_FAVORITES)
  map.put("INSIGHTS_TAB_RECENTLY_VIEWED", Res.string.INSIGHTS_TAB_RECENTLY_VIEWED)
  map.put("LEGAL_PRODUCT_SCREEN_TITLE", Res.string.LEGAL_PRODUCT_SCREEN_TITLE)
  map.put("LIFE_TODAY_ACTIVITY_CARD_LABEL", Res.string.LIFE_TODAY_ACTIVITY_CARD_LABEL)
  map.put("LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT", Res.string.LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT)
  map.put("LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT", Res.string.LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT)
  map.put("LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT", Res.string.LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT)
  map.put("LIFE_TODAY_DAILY_TASKS_SECTION", Res.string.LIFE_TODAY_DAILY_TASKS_SECTION)
  map.put("LIFE_TODAY_LOG_SYMPTOMS_LABEL", Res.string.LIFE_TODAY_LOG_SYMPTOMS_LABEL)
  map.put("LIFE_TODAY_MEAL_PLAN_CARD_LABEL", Res.string.LIFE_TODAY_MEAL_PLAN_CARD_LABEL)
  map.put("LIFE_TODAY_WATER_CARD_LABEL", Res.string.LIFE_TODAY_WATER_CARD_LABEL)
  map.put("LIFE_TODAY_WEIGHT_CARD_LABEL", Res.string.LIFE_TODAY_WEIGHT_CARD_LABEL)
  map.put("LOGIN_CONTACT_US_BUTTON", Res.string.LOGIN_CONTACT_US_BUTTON)
  map.put("LOGIN_EMAIL_PLACEHOLDER", Res.string.LOGIN_EMAIL_PLACEHOLDER)
  map.put("LOGIN_EMAIL_SENT_INSTRUCTIONS", Res.string.LOGIN_EMAIL_SENT_INSTRUCTIONS)
  map.put("LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT", Res.string.LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT)
  map.put("LOGIN_FORGOT_PASSWORD_BUTTON", Res.string.LOGIN_FORGOT_PASSWORD_BUTTON)
  map.put("LOGIN_LOGIN_BUTTON", Res.string.LOGIN_LOGIN_BUTTON)
  map.put("LOGIN_PASSWORD_PLACEHOLDER", Res.string.LOGIN_PASSWORD_PLACEHOLDER)
  map.put("LOGIN_SCREEN_TITLE", Res.string.LOGIN_SCREEN_TITLE)
  map.put("LOG_FOOD_ADD_FOOD_ACTION_BUTTON", Res.string.LOG_FOOD_ADD_FOOD_ACTION_BUTTON)
  map.put("LOG_FOOD_ADD_MEAL_SCREEN_TITLE", Res.string.LOG_FOOD_ADD_MEAL_SCREEN_TITLE)
  map.put("LOG_FOOD_AMOUNT_FIELD_LABEL", Res.string.LOG_FOOD_AMOUNT_FIELD_LABEL)
  map.put("LOG_FOOD_CAMERA_CANCEL_BUTTON", Res.string.LOG_FOOD_CAMERA_CANCEL_BUTTON)
  map.put("LOG_FOOD_CAMERA_LOADING_MESSAGE", Res.string.LOG_FOOD_CAMERA_LOADING_MESSAGE)
  map.put("LOG_FOOD_CAMERA_SCAN_BUTTON", Res.string.LOG_FOOD_CAMERA_SCAN_BUTTON)
  map.put("LOG_FOOD_CAMERA_SCREEN_TITLE", Res.string.LOG_FOOD_CAMERA_SCREEN_TITLE)
  map.put("LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE", Res.string.LOG_FOOD_FIND_FOOD_EMPTY_MESSAGE)
  map.put("LOG_FOOD_FIND_FOOD_EMPTY_TITLE", Res.string.LOG_FOOD_FIND_FOOD_EMPTY_TITLE)
  map.put("LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON", Res.string.LOG_FOOD_FIND_FOOD_SCAN_BARCODE_BUTTON)
  map.put("LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER", Res.string.LOG_FOOD_FIND_FOOD_SEARCH_FIELD_PLACEHOLDER)
  map.put("LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_CALORIES_UNIT_LABEL)
  map.put("LOG_FOOD_FOOD_DETAILS_CARBS_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_CARBS_LABEL)
  map.put("LOG_FOOD_FOOD_DETAILS_FAT_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_FAT_LABEL)
  map.put("LOG_FOOD_FOOD_DETAILS_FIBER_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_FIBER_LABEL)
  map.put("LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL", Res.string.LOG_FOOD_FOOD_DETAILS_PROTEIN_LABEL)
  map.put("LOG_FOOD_LOG_TIME_FIELD_LABEL", Res.string.LOG_FOOD_LOG_TIME_FIELD_LABEL)
  map.put("LOG_FOOD_SCAN_ERROR_IMAGE_TOO_LARGE", Res.string.LOG_FOOD_SCAN_ERROR_IMAGE_TOO_LARGE)
  map.put("LOG_FOOD_SCAN_ERROR_NOT_FOOD", Res.string.LOG_FOOD_SCAN_ERROR_NOT_FOOD)
  map.put("LOG_FOOD_SCAN_ERROR_QUOTA_EXCEEDED", Res.string.LOG_FOOD_SCAN_ERROR_QUOTA_EXCEEDED)
  map.put("LOG_FOOD_SCAN_ERROR_SERVICE_UNAVAILABLE", Res.string.LOG_FOOD_SCAN_ERROR_SERVICE_UNAVAILABLE)
  map.put("LOG_FOOD_SCAN_FOOD_BUTTON", Res.string.LOG_FOOD_SCAN_FOOD_BUTTON)
  map.put("LOG_FOOD_SCAN_RESULTS_ADD_BUTTON", Res.string.LOG_FOOD_SCAN_RESULTS_ADD_BUTTON)
  map.put("LOG_FOOD_SCAN_RESULTS_CLOSE_BUTTON", Res.string.LOG_FOOD_SCAN_RESULTS_CLOSE_BUTTON)
  map.put("LOG_FOOD_SCAN_RESULTS_DELETE_CANCEL", Res.string.LOG_FOOD_SCAN_RESULTS_DELETE_CANCEL)
  map.put("LOG_FOOD_SCAN_RESULTS_DELETE_CONFIRM", Res.string.LOG_FOOD_SCAN_RESULTS_DELETE_CONFIRM)
  map.put("LOG_FOOD_SCAN_RESULTS_DELETE_ITEM_TITLE", Res.string.LOG_FOOD_SCAN_RESULTS_DELETE_ITEM_TITLE)
  map.put("LOG_FOOD_SCAN_RESULTS_TITLE", Res.string.LOG_FOOD_SCAN_RESULTS_TITLE)
  map.put("LOG_FOOD_SCAN_RESULTS_TOTAL_LABEL", Res.string.LOG_FOOD_SCAN_RESULTS_TOTAL_LABEL)
  map.put("LOG_PERIOD_MARK_DATES_TITLE", Res.string.LOG_PERIOD_MARK_DATES_TITLE)
  map.put("LOG_SYMPTOMS_SCREEN_TITLE", Res.string.LOG_SYMPTOMS_SCREEN_TITLE)
  map.put("LOG_WATER_CLOSE_BUTTON", Res.string.LOG_WATER_CLOSE_BUTTON)
  map.put("LOG_WATER_PERSONAL_AMOUNT_LABEL", Res.string.LOG_WATER_PERSONAL_AMOUNT_LABEL)
  map.put("LOG_WATER_SCREEN_TITLE", Res.string.LOG_WATER_SCREEN_TITLE)
  map.put("MAGIC_LINK_EMAIL_PLACEHOLDER", Res.string.MAGIC_LINK_EMAIL_PLACEHOLDER)
  map.put("MAGIC_LINK_INSTRUCTIONS", Res.string.MAGIC_LINK_INSTRUCTIONS)
  map.put("MAGIC_LINK_SCREEN_TITLE", Res.string.MAGIC_LINK_SCREEN_TITLE)
  map.put("MAGIC_LINK_SEND_BUTTON", Res.string.MAGIC_LINK_SEND_BUTTON)
  map.put("MAGIC_LINK_SUCCESS_MESSAGE", Res.string.MAGIC_LINK_SUCCESS_MESSAGE)
  map.put("MAGIC_LINK_SUCCESS_TITLE", Res.string.MAGIC_LINK_SUCCESS_TITLE)
  map.put("MAIN_BANNER_APP_PROMO_TITLE", Res.string.MAIN_BANNER_APP_PROMO_TITLE)
  map.put("MAIN_NAVIGATION_CHAT_LABEL", Res.string.MAIN_NAVIGATION_CHAT_LABEL)
  map.put("MAIN_NAVIGATION_DAILY_LABEL", Res.string.MAIN_NAVIGATION_DAILY_LABEL)
  map.put("MAIN_NAVIGATION_INSIGHTS_LABEL", Res.string.MAIN_NAVIGATION_INSIGHTS_LABEL)
  map.put("MAIN_NAVIGATION_MAIN_LABEL", Res.string.MAIN_NAVIGATION_MAIN_LABEL)
  map.put("MAIN_NAVIGATION_ME_LABEL", Res.string.MAIN_NAVIGATION_ME_LABEL)
  map.put("MAIN_NAVIGATION_TODAY_LABEL", Res.string.MAIN_NAVIGATION_TODAY_LABEL)
  map.put("MEAL_PLAN_LOG_FOOD_BUTTON", Res.string.MEAL_PLAN_LOG_FOOD_BUTTON)
  map.put("MED_TODAY_SCREEN_TITLE", Res.string.MED_TODAY_SCREEN_TITLE)
  map.put("MED_TODAY_STEPS_FORMAT", Res.string.MED_TODAY_STEPS_FORMAT)
  map.put("ME_BMI_GOAL_VALUE_FORMAT", Res.string.ME_BMI_GOAL_VALUE_FORMAT)
  map.put("ME_CALORIES_HISTORY_SECTION", Res.string.ME_CALORIES_HISTORY_SECTION)
  map.put("ME_DAYS_IN_A_ROW_LABEL", Res.string.ME_DAYS_IN_A_ROW_LABEL)
  map.put("ME_DAYS_IN_A_ROW_VALUE", Res.string.ME_DAYS_IN_A_ROW_VALUE)
  map.put("ME_SCREEN_TITLE_FORMAT", Res.string.ME_SCREEN_TITLE_FORMAT)
  map.put("ME_WEIGHT_HISTORY_SECTION", Res.string.ME_WEIGHT_HISTORY_SECTION)
}
